export default {
  GQL_EP: process.env.NEXT_PUBLIC_GRAPHQL_EP,
  GQL_AUTH_EP: process.env.NEXT_PUBLIC_GRAPHQL_AUTH_EP,
  IMAGES_BASE_URL: process.env.NEXT_PUBLIC_LISTINGS_IMAGES_BASE_URL,
  CDN2_IMAGES_BASE_URL: process.env.NEXT_PUBLIC_CDN2_IMAGES_BASE_URL,
  IMAGES_CDN_BASE_URL: process.env.NEXT_PUBLIC_IMAGES_CDN_BASE_URL,
  ICONS_BASE_URL: process.env.NEXT_PUBLIC_ICONS_BASE_URL,
  ASSETS_BASE_URL:
    process.env.NEXT_PUBLIC_ASSETS_BASE_URL || "https://assets.aqar.fm/",
  PARTNERS_BASE_URL: process.env.NEXT_PUBLIC_PARTNERS_LOGOS_BASE_URL,
  GM_API_KEY: process.env.NEXT_PUBLIC_GM_API_KEY,
  GM_SET_API_KEY: process.env.NEXT_PUBLIC_GM_SET_API_KEY,
  LISTINGS_PAGE_SIZE: 20,
  MAP_PAGE_SIZE: 50,
  USER_FEES_PAGE_SIZE: 20,
  LISTINGS_DEFAULT_SORTER: { create_time: "desc", has_img: "desc" },
  REGION_HEADER_SIZE: 5,
  NUMBER_PRELOADED_IMAGES: 4,
  NUMBER_PRELOADED_LISTING_IMAGES: 2,
  NUMBER_RELATED_LISTINGS: 3,
  BUILD_TARGET: process.env.NEXT_PUBLIC_BUILD_TARGET,
  AQAR_WEB: process.env.NEXT_PUBLIC_AQAR_WEB_EP,
  GA_TRACKING_ID: process.env.NEXT_PUBLIC_GA_TRACKING_ID,
  HOST_URL: process.env.NEXT_PUBLIC_HOST_URL,
  APP_LINK: process.env.NEXT_PUBLIC_APP_LINK,
  GGL_TAGS: process.env.NEXT_PUBLIC_APP_GGL_TAGS,
  AHLI_REQUEST_VERSION: process.env.NEXT_PUBLIC_AHLI_REQUEST_VERSION,
  APPLE_PAY_VERSION_NUMBER: 5,
  GA4_TRACKING_ID: process.env.NEXT_PUBLIC_GA4_TRACKING_ID,
  serverRuntimeSecret: process.env.NEXT_PUBLIC_SERVER_RUNTIME_SECRET,
};
